export default __webpack_public_path__ + "static/media/reunion21_w1024.b8457a12.jpg";